var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex flex-row space-x-5"
  }, [!_vm.hidePolicies ? _c('a', {
    staticClass: "text-center color--dark--grey text-email",
    attrs: {
      "href": "/policies",
      "target": "blank"
    }
  }, [_vm._v("Policies")]) : _vm._e(), _vm._v(" "), !_vm.hideEmail ? _c('a', {
    staticClass: "text-center color--dark--grey text-email",
    attrs: {
      "href": `mailto:${_vm.overrideEmail || 'hey@extra.app'}`
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.overrideEmail || 'hey@extra.app') + "\n\t")]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };